var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.894 20.448A1 1 0 0 1 20 21H5.5c-.632 0-.932-.563-1.2-1.045a11 11 0 0 1-.738-1.616c-.5-1.364-.917-3.293-.548-5.503a11.6 11.6 0 0 1 1.428-3.993c.655-1.109 1.93-1.42 2.99-1.137l2.188.586 1.035-3.864a3 3 0 1 1 5.796 1.553l-1.036 3.864 1.358.364c1.654.443 2.51 2.119 2.278 3.655-.11.73-.154 1.447-.065 1.968.114.67.53 1.537.985 2.306.38.644.74 1.142.816 1.244.227.308.28.719.107 1.066Zm-7.082-16.21a1 1 0 0 0-1.225.708l-1.294 4.83a1.001 1.001 0 0 1-1.225.707l-3.152-.845c-.383-.103-.646.043-.751.221a9 9 0 0 0-.703 1.495l11.51 3.053c.025-.294.06-.578.1-.842.106-.691-.296-1.285-.817-1.424l-2.323-.623a1 1 0 0 1-.707-1.225l1.294-4.83a1 1 0 0 0-.707-1.225Zm3.272 12.267L4.966 13.291c-.26 1.724.067 3.248.474 4.36.208.569.434 1.022.605 1.329l.012.02h1.7c-.377-.792-.763-1.866-.77-2.993a1 1 0 1 1 1.999-.014c.005.776.307 1.614.656 2.308.138.276.277.515.392.7h8.125c-.403-.7-.86-1.61-1.075-2.496Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearFilters);
export default __webpack_public_path__ + "static/media/clear_filters.e6701da7553d9e445ec9b17cbde5bbc7.svg";
export { ForwardRef as ReactComponent };